




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Button extends Vue {
    @Prop() id? : string;
    @Prop() name? : string;
    @Prop() type? : string;
    @Prop() btnClass? : string;

    private sendEvent(e: MouseEvent) {
        this.$emit('event', e);
    }
}
